import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import catImage from "../../src/assets/cat-selection.png";
import { useAuthStore } from '../store/useAuthStore';


const WelcomeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate(); 

  const handleCreateAccount = (authUser, OnClose) => {
    // If user is already authenticated, dont redirect
    if (!authUser) {
      OnClose();
      navigate("/signup");
    }
    else {
      OnClose();
    }
  };
  // Use auth store to get user data
  const { authUser } = useAuthStore();
  // Track screen size
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add CSS for animations when component mounts
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideUp {
        from { transform: translateY(30px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }

      .modal-overlay {
        animation: fadeIn 0.3s ease-out forwards;
      }

      .modal-content {
        animation: slideUp 0.4s ease-out forwards;
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  if (!isOpen) return null;

  return (
    // Overlay container with an onClick handler to close the modal when clicked
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[150] backdrop-blur-sm modal-overlay"
      onClick={onClose}
    >
      {/* Modal content container stops the onClick event from bubbling up */}
      <div
        className="bg-[#e9d8c1] rounded-lg shadow-xl relative overflow-hidden modal-content"
        style={{
          maxHeight: isMobile ? '80vh' : '90vh',
          width: isMobile ? '90%' : '450px',
          maxWidth: isMobile ? '400px' : '450px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 transition-colors duration-200"
        >
          <X size={20} />
        </button>

        {/* Modal content */}
        <div className={isMobile ? "p-5 text-center" : "p-6 text-center"}>
          <h2 className={`${isMobile ? "text-xl" : "text-2xl"} font-medium ${isMobile ? "mb-3" : "mb-4"} text-gray-800`}>
            Welcome to Stayfur!
          </h2>

          <div className={`${isMobile ? "my-3" : "my-5"} relative`}>
            <img
              src={catImage}
              alt="cat"
              className={`mx-auto ${isMobile ? "h-28" : "h-40"} transition-transform hover:scale-105 duration-300`}
            />
          </div>

          <h3 className={`${isMobile ? "text-xl" : "text-2xl"} font-medium text-[#6C5F5B] ${isMobile ? "mt-2" : "mt-4"}`}>
            <span className="font-extrabold">Don’t Miss Out!</span> <br />
            Enjoy <span className="font-bold text-[#E74C3C]">RM20</span> OFF Your First Booking
          </h3>

          <p className={`text-gray-600 ${isMobile ? "text-sm mt-2 mb-4" : "mt-4 mb-6"}`}>
            Sign up in 10 seconds & unlock your discount instantly!
          </p>
          {/* Check if the user sign up or not if not show the sign up now else show the make booking button */}
          <button
            className={`
            inline-block
            bg-gradient-to-r
            from-[#e98c55]
            to-[#dfa981]
            text-white
            ${isMobile ? "px-5 py-2 w-full" : "px-6 py-3 w-4/5"}
            rounded-lg
            hover:shadow-lg
            hover:translate-y-[-2px]
            transition-all
            duration-200
            shadow-md
            `}
            onClick={handleCreateAccount.bind(null, authUser, onClose)}
          >
            {!authUser ? "Claim My RM20" : "Make A Booking Now"}
          </button>
          <p className={`text-xs text-gray-600 ${isMobile ? "mt-2" : "mt-4"}`}>
            *Offer valid for new customers only. Terms and conditions apply.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
